import {Snippet} from './snippet';

export class SnippetDto {
  snippet: Snippet;
  categories: number[];
}
